<template>
  <b-modal id="termPolicyEnrollmentModal" modal-class="client-details-modal" centered size="md" hide-footer no-close-on-backdrop hide-header-close @hidden="resetForm" 
  :visible="showModal"
>
    <!-- Modal Header -->
    <template #modal-header>
        <div class="view-clients-header">
            <b-button variant="close-btn" class="btn-container" @click="resetForm">
                <i class="fas fa-times"></i>
            </b-button>
        </div>
    </template>

    <b-container fluid>
        <div class="form-part">
            <div class="title-text text-center mb-3">
                <h5><strong>Withdraw Enrollment</strong></h5>
            </div>
            <div class="plan-details mb-4">
                <p><strong>PolicyID:</strong> {{ member?.policy_id }}</p>
                <p>
                    <strong>Name:</strong> {{ member?.Member }}
                </p>
                <p>
                    <strong>Plan Details:</strong>
                    {{ member?.plan }}
                </p>
            </div>

            <form @submit.prevent="submitNote">
                <div class="mb-4">
                    <label for="effectiveDate">Withdraw Date <span class="text-danger">*</span></label>
                    <b-form-select id="effectiveDate" v-model="form.tdate" class="memberSearch-field mt-2" >
                        <template #first>
                            <option value="" disabled selected>Select an Withdraw Date</option>
                        </template>
                        <option :value="member?.effective_date" selected disabled>
                            {{ member?.effective_date }}
                        </option>
                    </b-form-select>
                    <div v-if="$v.form.tdate.$dirty && !$v.form.tdate.required" class="text-danger">
                        Effective date is required.
                    </div>
                </div>

                <div class="mb-4">
                    <label for="action">Action <span class="text-danger">*</span></label>
                    <b-form-input id="action" :value="form.action" disabled class="memberSearch-field mt-2" />
                    <div v-if="$v.form.action.$dirty && !$v.form.action.required" class="text-danger">
                        Action type is required.
                    </div>
                </div>

                <div class="mb-4">
                    <label for="reason">Reason <span class="text-danger">*</span></label>
                    <b-form-textarea id="reason" v-model="form.text" rows="3" class="memberSearch-field mt-2" placeholder="Enter your reason" />
                    <div v-if="$v.form.text.$dirty && !$v.form.text.required" class="text-danger">
                        Reason is required.
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-4">
                    <button type="submit" class="group-univ-btn text-center" :disabled="isSubmitting">
                        <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
                        Submit
                    </button>
                </div>
            </form>
        </div>
    </b-container>
</b-modal>
</template>

<script>
import axios from "axios";
import {
    required
} from "vuelidate/lib/validators";
import helper from "@/resource/Helper";
import Helper from "../../resource/Helper";

export default {
    data() {
        return {
            form: {
                tdate: "",
                text: "",
                action: "",
            },
            isSubmitting: false,
            actionPerformed: "withdraw",
            statusOptions: [],
            actionOptions: [{
                    value: "withdraw",
                    text: "Withdraw"
                },
            ],
        };
    },
    props: {
        member: Object,
        showModal: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        showModal: {
            handler() {
                this.form.tdate = this.member?.effective_date;
                this.$set(this.form, "action", "Withdrawn for Other (WNO)");
            },
            deep: true
        }
    },
    validations: {
        form: {
            tdate: {
                required
            },
            text: {
                required
            },
            action: {
                required
            },
        },
    },
    methods: {
        async submitNote() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.isSubmitting = true;
            let loader = this.$loading.show();
            this.error = null;
            try {
                const url =`${process.env.VUE_APP_API_ADMIN_URL}/api/v1/withdraw-policy`;

                const payload = {
                    policy_id: this.member?.policy_id,
                    tdate: new Date(this.form.tdate).toISOString().split("T")[0],
                    action:"wno",
                    reason: this.form.text,
                    aid: this.$store.getters.repId,
                    sendEmail: 1,
                };

                const response = await axios.post(url, payload,{
                    headers: {
                        "X-Internal-Token": Helper.nueraProtectedApiToken(),
                    }
                });
                if (response.status === 200) {
                    helper.infoMessage(this, "success", response.data.message);
                }
            } catch (err) {
                console.error("Error submitting note:", err);
                helper.infoMessage(this, "error", "Failed to submit the request. Please try again later.");
                this.error = "Failed to submit the request. Please try again later.";
            } finally {
                loader.hide();
                this.$bvModal.hide("termPolicyEnrollmentModal");
                this.$parent.getData();
                this.isSubmitting = false;
            }
        },

        resetForm() {
            this.form = {
                tdate: "",
                text: "",
                action: "",
            };
            this.actionPerformed = "";
            this.$v.$reset();
            this.$bvModal.hide("termPolicyEnrollmentModal");
            this.$emit("onCloseModal");
        },

    },
};
</script>

<style>
.form-part label {
    font-size: 14px;
    font-weight: 600;
    color: #333;
}

.client-details-modal .modal-content .modal-body {
    max-height: 700px !important;
}
</style>
